module.exports = __webpack_public_path__ + "media/images/pages/bg_area_09-1413805d9c597571f69c7e81a6175ec8.png";